import { ISelectItem } from '../components/SelectField/types';

export const AVAILABLES: ISelectItem[] = [
  { value: 1, label: 'available' },
  { value: 0, label: 'unavailable' },
];
